import { AxiosResponse } from 'axios';

import { IListingAddAnOwnerForm } from '../../components/Listings/ListingAddAnOwner/ListingAddAnOwner.types';
import { IListingRequest } from '../../pages/ListingDetail/ListingDetail.types';
import httpRequest from '../httpRequest';

const LISTINGS_STATUS = ['active', 'draft', 'pending', 'deleted'];

const listingsAPI = {
  getListings: async (
    statusFilters: string[],
    page = 1,
    perPage = 10,
  ): Promise<AxiosResponse> => {
    const getListingsStatusQueryString = (arr: string[]) => {
      return arr.map(str => `status[]=${str}`).join('&');
    };

    const statusQueryString =
      statusFilters.length === 0
        ? getListingsStatusQueryString(LISTINGS_STATUS)
        : getListingsStatusQueryString(statusFilters);

    const response = (await httpRequest({
      baseURL: process.env.REACT_APP_API_URL,
      url: `/property?${statusQueryString}&page=${page}&perPage=${perPage}`,
      method: 'GET',
    })) as AxiosResponse;

    return response;
  },

  getListingDetail: async (property_id: number): Promise<AxiosResponse> => {
    const response = (await httpRequest({
      baseURL: process.env.REACT_APP_API_URL,
      url: `/property?id=${property_id}`,
      method: 'GET',
    })) as AxiosResponse;

    return response;
  },

  updateListing: async ({
    property_id,
    payload,
  }: {
    property_id: number;
    payload: Partial<IListingRequest>;
  }): Promise<AxiosResponse> => {
    const response = (await httpRequest({
      baseURL: process.env.REACT_APP_API_URL,
      url: `/property/${property_id}`,
      method: 'PUT',
      data: payload,
    })) as AxiosResponse;

    return response;
  },

  createOrUpdateOwner: async ({
    property_id,
    payload,
  }: {
    property_id: number;
    payload: IListingAddAnOwnerForm;
  }): Promise<AxiosResponse> => {
    const response = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/properties/${property_id}/owners`,
      method: 'POST',
      data: payload,
    })) as AxiosResponse;

    return response;
  },

  getListingOwners: async (property_id: number): Promise<AxiosResponse> => {
    const response = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/properties/${property_id}/owners`,
      method: 'GET',
    })) as AxiosResponse;

    return response;
  },

  deleteListingOwner: async ({
    property_id,
    user_id,
  }: {
    property_id: number;
    user_id: number;
  }): Promise<AxiosResponse> => {
    const response = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/properties/${property_id}/owners/${user_id}`,
      method: 'DELETE',
    })) as AxiosResponse;

    return response;
  },
};

export default listingsAPI;
